import React, { ReactElement } from 'react'
import { useTranslate } from 'src/localization/Trns'

import style from './DeactivationNotice.style'

interface DeactivationNoticeProps {
  billingCycleEnd: string | null
  overBy: number
  // When true, the body uses "excess virtual cards" (no number). When false,
  // it names the exact count. Callers pass false only when usage is known and
  // over the Starter limit.
  withinLimit: boolean
}

export default function DeactivationNotice(
  props: DeactivationNoticeProps,
): ReactElement {
  const { billingCycleEnd, overBy, withinLimit } = props
  const translate = useTranslate()

  const title = billingCycleEnd
    ? translate(
        'On ${billingCycleEnd}, Extend will automatically deactivate cards over your Starter plan limit.',
        { billingCycleEnd },
      )
    : translate(
        'At the end of your billing cycle, Extend will automatically deactivate cards over your Starter plan limit.',
      )

  const body = withinLimit
    ? billingCycleEnd
      ? translate(
          'When your downgrade takes effect on ${billingCycleEnd}, Extend will automatically deactivate excess virtual cards to meet the Starter plan limit. Cards with the least recent spend activity will be deactivated first, while cards used most recently will remain active. Deactivated cards cannot process transactions.',
          { billingCycleEnd },
        )
      : translate(
          'When your downgrade takes effect at the end of your billing cycle, Extend will automatically deactivate excess virtual cards to meet the Starter plan limit. Cards with the least recent spend activity will be deactivated first, while cards used most recently will remain active. Deactivated cards cannot process transactions.',
        )
    : billingCycleEnd
      ? translate(
          'When your downgrade takes effect on ${billingCycleEnd}, Extend will automatically deactivate ${count} virtual cards to meet the Starter plan limit. Cards with the least recent spend activity will be deactivated first, while cards used most recently will remain active. Deactivated cards cannot process transactions.',
          { billingCycleEnd, count: String(overBy) },
        )
      : translate(
          'When your downgrade takes effect at the end of your billing cycle, Extend will automatically deactivate ${count} virtual cards to meet the Starter plan limit. Cards with the least recent spend activity will be deactivated first, while cards used most recently will remain active. Deactivated cards cannot process transactions.',
          { count: String(overBy) },
        )

  return (
    <div css={style} className="DeactivationNotice">
      <p className="DeactivationNotice-title">{title}</p>
      <p className="DeactivationNotice-body">{body}</p>
    </div>
  )
}
